import { Routes } from '@angular/router';
import { questionnaireAnalyticsRoutes } from './analytics/questionnaire-analytics.routes';
import { questionnaireBuilderUnsavedGuard } from './builder/questionnaire-builder-unsaved.guard';

export const questionnaireRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./questionnaire.component').then((m) => m.QuestionnaireComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        canDeactivate: [questionnaireBuilderUnsavedGuard],
        loadComponent: () =>
          import('./builder/questionnaire-builder.component').then(
            (m) => m.QuestionnaireBuilderComponent,
          ),
      },
    ],
  },
  {
    path: ':questionnaireGuid',
    loadComponent: () =>
      import('./questionnaire.component').then((m) => m.QuestionnaireComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'editor',
      },
      {
        path: 'editor',
        canDeactivate: [questionnaireBuilderUnsavedGuard],
        loadComponent: () =>
          import('./builder/questionnaire-builder.component').then(
            (m) => m.QuestionnaireBuilderComponent,
          ),
      },
      {
        path: 'analytics',
        children: questionnaireAnalyticsRoutes,
      },
      {
        path: 'invites',
        loadComponent: () =>
          import('./invites/questionnaire-invites.component').then(
            (m) => m.QuestionnaireInvitesComponent,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./settings/questionnaire-settings.component').then(
            (m) => m.QuestionnaireSettingsComponent,
          ),
      },
    ],
  },
];
